module.exports = __webpack_public_path__ + "static/media/Down.0dc5cb90.svg";